import DeviceInfo from "react-native-device-info";
import { IDFA } from "@lib/idfa";
import { Platform, NativeModules } from "react-native";
import { getRefererData } from "@utils/PlayReferrer";

const getUserData = async () => {
  const [idfa, ip, package_referrer, buildID, manufacturer] = await Promise.all(
    [
      IDFA.getIDFA(),
      DeviceInfo.getIpAddress(),
      DeviceInfo.getInstallerPackageName(),
      DeviceInfo.getBuildId(),
      DeviceInfo.getManufacturer(),
    ],
  );

  let play_referrer;
  let referer = {};
  try {
    const refererObject = await getRefererData();
    const {
      installReferrer,
      referrerClickTimestampSeconds,
      installBeginTimestampSeconds,
      referrerClickTimestampServerSeconds,
      installBeginTimestampServerSeconds,
    } = refererObject || {};
    play_referrer = installReferrer;
    referer = {
      referrerClickTimestampSeconds,
      installBeginTimestampSeconds,
      referrerClickTimestampServerSeconds,
      installBeginTimestampServerSeconds,
    };
  } catch (e) {
    console.log(e);
  }

  const user_data = {
    idfa,
    deviceid: DeviceInfo.getDeviceId(),
    ip,
    os: Platform.OS,
    buildID,
    manufacturer,
    locale: NativeModules.I18nManager.localeIdentifier,
    platform: Platform.OS,
    brand: Platform.constants.Brand,
    os_version: `${DeviceInfo.getSystemVersion()}`,
    model: Platform.constants.Manufacturer,
    app_version: DeviceInfo.getVersion(),
    package_referrer,
    play_referrer,
    referer,
  };

  return user_data;
};

export default getUserData;
